mainApp.component('cloudAccessPolicy', {
	templateUrl: '/public/components/cloudAccess/cloud-access-policy.component.html',
	bindings: {
	},
	controller: cloudAccessPolicyController
});

function cloudAccessPolicyController($scope, $state, GeneralUtilsService, CloudAccessService, FieldsService, RulesService, IconsService) {

    const ctrl = this;
    const FieldTypes = FieldsService.getFieldTypes();
    ctrl.loading = false;
    ctrl.rulesType = 'CLOUDACCESSRULE';
    ctrl.deletedRulesIds = [];
    ctrl.changedRulesMap = new Map();

    ctrl.showNoSettingsWarning = false;

    let tableHeader = [
      { 'label': 'Rule Name', 'path': 'description', noSort: true },
      { 'label': 'Users / Groups', 'path': 'from', noSort: true },
      { 'label': 'Remote Access Applications', 'path': 'to', noSort: true },
      { 'label': 'Enable', 'path': '', noSort: true },
      { 'label': '', 'path': '', noSort: true },
    ];

    ctrl.$onInit = function () {
        reload();
    };

    ctrl.$doCheck = function () {
        // iterates over all rules in screen. if any rule was changed we save it's index and data.
        $scope.tableConfig.items.forEach(function (tableRule) {
            if (ctrl.saving) {
                return;
            }
            let index = ctrl.origConfiguration.cloudAccessRules.findIndex(origRule => origRule.id === tableRule.id);
            if (index != -1 && !ctrl.changedRulesMap.has(index) && !angular.equals(ctrl.origConfiguration.cloudAccessRules[index], tableRule)) {
                ctrl.changedRulesMap.set(index, tableRule);
            }
        });
    }

    function reload() {
        ctrl.loading = true;
        ctrl.clearCollections();

        //get data from server (cloudAccessConfiguration)
        CloudAccessService.getCloudAccessSettings($state.params.accountId, function (data){
            ctrl.cloudAccessConfiguration = data.cloudAccessConfiguration;
            if (!ctrl.cloudAccessConfiguration.settings || !ctrl.cloudAccessConfiguration.settings.fqdn) {
                ctrl.showNoSettingsWarning = true;
            }
            ctrl.origConfiguration = angular.copy(ctrl.cloudAccessConfiguration);
            ctrl.datamodified = new Date().getTime();
            ctrl.origConfiguration.cloudAccessRules.forEach(function (rule) {
                let index = $scope.tableConfig.items.findIndex(tableRule => rule.id === tableRule.id);
                if (index != -1) {
                    $scope.tableConfig.items[index] = rule;
                }
            })

            ctrl.loading = false;
            ctrl.saving = false;

            $scope.$digest();
        });
    }

    ctrl.hasChanges = function() {
        return !angular.equals(ctrl.origConfiguration, ctrl.cloudAccessConfiguration) || ctrl.deletedRulesIds.length > 0 || ctrl.changedRulesMap.size > 0;
    };

    ctrl.saveChanges = function() {
        ctrl.saving = true;
        ctrl.changedRulesMap.forEach(ctrl.updateRules);
        ctrl.cloudAccessConfiguration.cloudAccessRules = ctrl.cloudAccessConfiguration.cloudAccessRules.filter(function (rule) {
            return !ctrl.deletedRulesIds.includes(rule.id);
        })
        CloudAccessService.saveAccountWithCloudConfiguration ($state.params.accountId,ctrl.cloudAccessConfiguration, onSaveSuccess, onSaveError);
    };

    ctrl.updateRules = function(newRule, index, changedRulesMap) {
        ctrl.cloudAccessConfiguration.cloudAccessRules[index] = newRule;
    }

    let onSaveSuccess = (data) => {
        $scope.$root.handleServerResponse(data, '', 'Changes saved successfully');
        $scope.$broadcast('stop-load');
        reload();
    };

    let onSaveError = (data) => {
         $scope.$root.handleServerResponse(data, '', '');
         $scope.$broadcast('stop-load');
    };

    ctrl.fields = {
            from: {
                name: 'From',
                id: 'from',

                types: [
                {
                    name: 'All authenticated users',
                    fixed_display_name: 'All authenticated users',
                    field: {
                        type: 'Any',
                        output: () => {
                            return {'id': -1, 'name': 'Any', 'display_name': 'All authenticated users'};
                        },
                    },
                },
                {
                    name: 'Groups',
                    field: FieldTypes.groups,
                },
                {
                    name: 'Directory Users',
                    field: FieldTypes.dsUser,
                }, {
                    name: 'VPN Users',
                    field: FieldTypes.accesslogins,
                }
                ],
            },
            to: {
                name: 'To',
                id: 'to',
                types: [
                    {
                        name: 'Remote Access Applications',
                        field: FieldTypes.cloudApps,
                    }],
            }
    };

    $scope.tableConfig = {
        hasChanges: ctrl.hasChanges,
        searchId: $state.params.ruleId,
        type: 'CLOUDACCESSRULE',
        dataURL: function () {
            return '/getCloudPolicy?accountId=' + ($state.params.accountId ? $state.params.accountId : '');
        },
        processData: function (items) {
            ctrl.tableProcessDataSuccess();
            return items;
        },
        titleSearch: 'Rules',
        alternativeHead: tableHeader,
        searchField: 'description',
        noSearch: true,
        noDataMessage: ' ',
        specialActions: [
            {
                icon: 'simple-plus',
                text: 'ADD RULE',
                tooltip: 'Add',
                id: 'add-fwRule',
                func: function (selectedItems, tableConfig) {
                    let newRule = {id: GeneralUtilsService.getRandomId(), description: ' Remote Access Rule ' + (tableConfig.items.length + 1), name: "CludAccessRule" , type: "CLOUDACCESSRULE", from:[], to:[], ruleEnabled:true};
                    tableConfig.items.push(newRule);
                    // add to ctrl rules
                    ctrl.cloudAccessConfiguration.cloudAccessRules.push(newRule);
                },
            },
        ],
        rulesFields: ctrl.fields,
        fields: [
            {
                label: '', path: '', noSort: true, template: '<cloud-access-rule item="item" table-config="tableConfig"  rule-type="tableConfig.type" field="tableConfig.rulesField" fields="tableConfig.rulesFields"></cloud-access-rule>'
            },
        ],
        extraFieldsToSearch: [{ path: 'description' }],
        defer: true,
        sortList: [{ sortField: 'id', sortDir: 'ASC' }],
        pageSize: 50,
        hideCheckboxes: true,
        noAutoSelect: true,
        nameField: 'description',
        innerLoader: true,
        icons: IconsService.getIcons('policy'),
        items: [],
        deleteRule: function (item) {
            // remove from $scope.tableConfig.items
           const itemIndexToRemove = $scope.tableConfig.items.indexOf(item);
           $scope.tableConfig.items.splice(itemIndexToRemove, 1);
           // save ID to remove before saving
           ctrl.deletedRulesIds.push(item.id);
        },
        allowPropagation: true,
        stickyHead: true,
        keepPageOnRefresh: true,
        onPageChange: function() {
            ctrl.clearCollections();
            ctrl.saving = false;
        }
    };

    ctrl.tableProcessDataSuccess = function() {
        ctrl.saving = false;
    }

    ctrl.clearCollections = function() {
        ctrl.saving = true;
        ctrl.revertTableChanges();
        ctrl.deletedRulesIds = [];
        ctrl.changedRulesMap = new Map();
    }

    ctrl.revertTableChanges = function() {
        ctrl.changedRulesMap.forEach(ctrl.revertTableRule);
    }

    ctrl.revertTableRule = function(tableRule, originalRuleIndex, changedRulesMap) {
        let index = $scope.tableConfig.items.findIndex(rule => rule.id === tableRule.id);
        $scope.tableConfig.items[index] = ctrl.origConfiguration.cloudAccessRules[originalRuleIndex];
    }
}